import { Permission } from "./permission";

export class User {
  id: number;
  empresaId: number;
  empresaNome: string;
  empresaMidiaCaminho: string;
  empresaMidiaMimeType: string;
  midiaCaminho: string;
  midiaRetangularCaminho: string;
  midiaMimeType: string;
  primeiroNome: string;
  ultimoNome: string;
  email: string;
  emailAdministrador: string;
  codigoCIAM: string;
  codigoAcesso: string;
  cargoEmpresa: string;
  locacao: string;
  areaId: number;
  areaNome: string;
  idiomaPadrao: string;
  ativo: boolean;
  admin: boolean;
  superAdmin: boolean;
  usuarioCIAM: any;
  empresaAcessoAgendamentoReunioes: boolean;
  empresaAcessoInformacoesCompliance: boolean;
  empresaAcessoPoliticasCompliance: boolean;
  empresaAcessoTreinamentos: boolean;
  empresaCorPadrao: string; 
  corPrimaria: string;
  empresaMidiaRetangularCaminho: string;
  empresaMidiaRetangularMimeType: string;
  empresaEstruturaCompliance: string;
  empresaIdIntegracaoAV: string;
  empresaIdInstanciaAV: string;
  estruturaCompliance: string;
  empresaCanalDenunciaDescricao: string;
  canalDenunciaDescricao?: string;
  empresaCanalDenunciaSite: string;
  canalDenunciaSite: string;
  empresaCanalDenunciaTelefone: string;
  canalDenunciaTelefone: string;
  empresaCanalDenunciaContato: string[];
  canalDenunciaContato: string[];
  permissoes: Permission[];

  constructor(obj?: any) {
    if (obj) {
      this.id = obj.id;
      this.empresaId = obj.empresaId;
      this.empresaNome = obj.empresaNome;
      this.empresaMidiaCaminho = obj.empresaMidiaCaminho;
      this.empresaMidiaMimeType = obj.empresaMidiaMimeType;
      this.midiaMimeType = obj.midiaMimeType;
      this.midiaCaminho = obj.midiaCaminho;
      this.primeiroNome = obj.primeiroNome;
      this.ultimoNome = obj.ultimoNome;
      this.email = obj.email;
      this.codigoCIAM = obj.codigoCIAM;
      this.cargoEmpresa = obj.cargoEmpresa;
      this.locacao = obj.locacao;
      this.areaId = obj.areaId;
      this.areaNome = obj.areaNome;
      this.idiomaPadrao = obj.idiomaPadrao;
      this.ativo = obj.ativo;
      this.admin = obj.admin;
      this.superAdmin = obj.superAdmin;
      this.usuarioCIAM = obj.usuarioCIAM;
      this.empresaAcessoAgendamentoReunioes =
        obj.empresaAcessoAgendamentoReunioes;
      this.empresaAcessoInformacoesCompliance =
        obj.empresaAcessoInformacoesCompliance;
      this.empresaAcessoPoliticasCompliance =
        obj.empresaAcessoPoliticasCompliance;
      this.empresaAcessoTreinamentos = obj.empresaAcessoTreinamentos;
      this.permissoes = obj.permissoes;
      this.empresaCorPadrao = obj.empresaCorPadrao;
      this.empresaMidiaRetangularCaminho = obj.empresaMidiaRetangularCaminho;
      this.empresaMidiaRetangularMimeType = obj.empresaMidiaRetangularMimeType;
      this.empresaEstruturaCompliance = obj.empresaEstruturaCompliance;
      this.empresaCanalDenunciaDescricao = obj.empresaCanalDenunciaDescricao;
      this.empresaCanalDenunciaSite = obj.empresaCanalDenunciaSite; 
      this.empresaCanalDenunciaTelefone = obj.empresaCanalDenunciaTelefone;
      this.empresaCanalDenunciaContato = obj.empresaCanalDenunciaContato;
      this.empresaIdIntegracaoAV = obj.empresaIdIntegracaoAV;
      this.empresaIdInstanciaAV = obj.empresaIdInstanciaAV;
    }
  }
}